import '../styles/ContactCopyRecovery.css';
import React, { useCallback, useEffect, useRef, useState } from 'react';

const EMAIL = 'umangsuthar97@gmail.com';
const RESET_DELAY = 2200;

function CopyGlyph() {
  return (
    <svg
      className="ccr-copy-icon"
      viewBox="0 0 16 16"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="5.5" y="5.5" width="8" height="8" rx="1.6" />
      <path d="M10.5 3.2V3a1.5 1.5 0 0 0-1.5-1.5H3A1.5 1.5 0 0 0 1.5 3v6A1.5 1.5 0 0 0 3 10.5h.2" />
    </svg>
  );
}

export default function ContactCopyRecovery() {
  const [copyStatus, setCopyStatus] = useState('idle');
  const timerRef = useRef(null);

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  useEffect(() => clearTimer, [clearTimer]);

  const handleCopy = async () => {
    clearTimer();
    const clipboard =
      typeof navigator !== 'undefined' && navigator.clipboard
        ? navigator.clipboard
        : null;

    if (!clipboard || typeof clipboard.writeText !== 'function') {
      setCopyStatus('unavailable');
      return;
    }

    try {
      await clipboard.writeText(EMAIL);
      setCopyStatus('copied');
      timerRef.current = setTimeout(() => {
        setCopyStatus('idle');
        timerRef.current = null;
      }, RESET_DELAY);
    } catch (err) {
      setCopyStatus('unavailable');
    }
  };

  return (
    <section
      className="ccr-root"
      aria-label="Copy email address"
      data-copy-status={copyStatus}
    >
      <div className="ccr-rail" data-content-rail="primary">
        <div className="ccr-measure">
          <div className="ccr-caption">
            <span className="ccr-leader" aria-hidden="true" />
            <p className="ccr-mark">Correspondence</p>

            <div className="ccr-row">
              <button
                type="button"
                className="ccr-copy"
                data-copy-state={copyStatus}
                onClick={handleCopy}
                aria-describedby="ccr-manual-hint"
              >
                <CopyGlyph />
                <span className="ccr-copy-label">Copy email address</span>
              </button>

              <p
                className="ccr-status"
                role="status"
                aria-live="polite"
                data-copy-state={copyStatus}
              >
                {copyStatus === 'copied' && (
                  <>
                    <span className="ccr-status-dot" aria-hidden="true" />
                    <span>Copied</span>
                  </>
                )}
                {copyStatus === 'unavailable' && (
                  <span>
                    Clipboard unavailable — the address below is selectable.
                  </span>
                )}
              </p>

              <p className="ccr-hint" id="ccr-manual-hint">
                If no mail handler or clipboard is available, select{' '}
                <span className="ccr-hint-address">{EMAIL}</span> and copy it
                by hand.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}